module.exports = __webpack_public_path__ + "static/MindMate-Naomi-9d073c2e92ff45694ec59ad5a5ad1515.png";